module.exports = __webpack_public_path__ + "media/images/android-f642f8fa8bb565b3a938ce51d9e0be8d.svg";